var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var Hamburger24 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentcolor' : _b, _c = _a.height, height = _c === void 0 ? '24px' : _c, _d = _a.width, width = _d === void 0 ? '24px' : _d, rest = __rest(_a, ["color", "height", "width"]);
    var svgStyle = __assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" }, { fill: color });
    return (React.createElement("div", __assign({ style: __assign({ "position": "relative" }, { height: height, width: width }) }, rest),
        React.createElement("svg", { viewBox: "0 0 24 24", xmlnsXlink: "http://www.w3.org/1999/xlink", style: svgStyle },
            React.createElement("desc", null, "Created with Sketch."),
            React.createElement("g", { id: "Hamburger_24_svg__Icons/Hamburger/24", stroke: "none", strokeWidth: 1, fillRule: "evenodd" },
                React.createElement("g", { transform: "translate(2.000000, 4.000000)", fillRule: "nonzero", id: "Hamburger_24_svg__Stroke" },
                    React.createElement("polygon", { points: "0 8 20 8 20 7 0 7" }),
                    React.createElement("polygon", { points: "0 15 20 15 20 14 0 14" }),
                    React.createElement("polygon", { points: "0 1 20 1 20 0 0 0" }))))));
};
Hamburger24.displayName = 'Hamburger24';
export default Hamburger24;
//# sourceMappingURL=hamburger-24.js.map